var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection",on:{"click":function($event){_vm.goToCollection(_vm.collection)}}},[_c('img',{staticClass:"cover",attrs:{"src":_vm.collection.get('cover'),"referrerpolicy":"no-referrer"}}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.collection.get('name')))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22689261","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collection/collectionItem.vue
// module id = 1490
// module chunks = 0